/* unplugin-vue-components disabled */
import {SourceTag} from 'components/sources-v2'
export default {
  components: {SourceTag},
  props: {
    preview: {
      type: Object,
      default: undefined
    },
    source: {
      type: Object,
      default: undefined
    },
    relativeDate: {
      type: String,
      default: undefined
    },
    date: {
      type: String,
      default: undefined
    }
  },
  computed: {
    image_url(){
      return this.preview?.image_url
    },
    formatted_date(){
      if (this.relativeDate) return this.relativeDate
      if (this.date) return $utils.format.date(this.date)
      return undefined
    }
  },
  methods: {
    onClick() {
      window.open(this.source.url, '_blank')
    },
  }
}
